module.exports = __webpack_public_path__ + "img/2063626.jpg";